import React, { useEffect, useState } from 'react';
import { Box, Typography, Breadcrumbs, Divider, Card, Button, Skeleton } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

// import { useResponseHandler } from '../../../../hooks/useResponseHandler';
import { formInitialValues } from './formik/formInitialValues';
import { validationSchema } from './formik/validationSchema';
import { ajustesGlobalesIaFormModel } from './formik/ajustesGlobalesIaFormModel';
import { AjustesGlobalesIaForm } from './components/forms/AjustesGlobalesIaForm';
import { editGlobalConfigStore, getDataFormDropDownStore, getGlobalConfigByIdStore } from 'store/services-ia-global-config';
import { useResponseHandler } from 'hooks/useResponseHandler';
// import { 
//     editGlobalConfigStore, 
//     getGlobalConfigByIdStore, 
//     getApplicationDataDropDownStore 
// } from '../../../../store/services-ia-global-config';

export const EditAjustesGlobalesIa = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { handleResponse, ResponseComponents } = useResponseHandler();
    const { formId, formField } = ajustesGlobalesIaFormModel;
    const [dataErrors, setMsgErrors] = useState([]);
    const [initialValues, setInitialValues] = useState<any>(formInitialValues);
    const [loading, setLoading] = useState(true);

    const { applicationsListSelect } = useSelector((state: any) => state.servicesIaGlobalConfig);

    useEffect(() => {
        dispatch(getDataFormDropDownStore());
    }, [dispatch]);

    useEffect(() => {
        // Solo cargar datos si la lista de aplicaciones ya cargó, para poder mapear los Selects
        if (applicationsListSelect && applicationsListSelect.length >= 0) {
            loadData();
        }
    }, [id, applicationsListSelect]);

    const loadData = async () => {
        if (!id) return;
        setLoading(true);
        const response = await dispatch(getGlobalConfigByIdStore(id));
        
        if (response?.ok && response?.data) {
            const item = response.data;
            setInitialValues({
                defaultChatServiceId: applicationsListSelect.find((p: any) => p.value === item.defaultChatServiceId) || undefined,
                defaultImageServiceId: applicationsListSelect.find((p: any) => p.value === item.defaultImageServiceId) || undefined,
                defaultAudioServiceId: applicationsListSelect.find((p: any) => p.value === item.defaultAudioServiceId) || undefined,
                defaultEmbeddingServiceId: applicationsListSelect.find((p: any) => p.value === item.defaultEmbeddingServiceId) || undefined,
                defaultOcrServiceId: applicationsListSelect.find((p: any) => p.value === item.defaultOcrServiceId) || undefined,
                creditsPerUsd: item.creditsPerUsd || '',
                defaultTemperature: item.defaultTemperature || '',
                defaultTopP: item.defaultTopP || '',
                defaultMaxTokens: item.defaultMaxTokens || '',
                enableStreaming: item.enableStreaming || false,
                enableMemory: item.enableMemory || false,
                enableCache: item.enableCache || false,
                enableTools: item.enableTools || false,
                enableLogs: item.enableLogs || false,
                allowBringYourOwnKey: item.allowBringYourOwnKey || false,
            });
        } else {
            navigate('/manager/plataforma-ia/configuracion/ajustes');
        }
        setLoading(false);
    };

    const handleSubmit = async (values: any, actions: any) => {
        if (!id) return;
        actions.setSubmitting(true);
        
        const mappedValues = {
            ...values,
            defaultChatServiceId: values.defaultChatServiceId?.value || values.defaultChatServiceId || null,
            defaultImageServiceId: values.defaultImageServiceId?.value || values.defaultImageServiceId || null,
            defaultAudioServiceId: values.defaultAudioServiceId?.value || values.defaultAudioServiceId || null,
            defaultEmbeddingServiceId: values.defaultEmbeddingServiceId?.value || values.defaultEmbeddingServiceId || null,
            defaultOcrServiceId: values.defaultOcrServiceId?.value || values.defaultOcrServiceId || null,
        };

        const response = await dispatch(editGlobalConfigStore(id, mappedValues));
        await handleResponse(response, 'Configuración Global Actualizada Con Éxito', true);
        actions.setSubmitting(false);

    };

   
    return (
        <Box sx={{ width: '100%' }}>
            {ResponseComponents}

            <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>Editar Configuración Global de IA</Typography>
            <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
                <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Manager</Typography>
                <Link color="inherit" to="/manager/plataforma-ia/configuracion/ajustes">
                    Configuración Global
                </Link>
                <Typography color="textPrimary">Editar</Typography>
            </Breadcrumbs>
            
            <Divider sx={{ marginBottom: 3 }}/>

            <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={validationSchema[0]}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting }) => (
                    <Card sx={{ mt: 2, p: 3, borderRadius: 2, boxShadow: '0px 12px 24px -4px rgba(145, 158, 171, 0.12)' }}>
                        <Form id={formId} autoComplete="off">
                            <AjustesGlobalesIaForm formField={formField} />

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
                                <Button 
                                    component={Link}
                                    to="/manager/plataforma-ia/configuracion/ajustes"
                                    color="inherit" 
                                    sx={{ borderRadius: 2, textTransform: 'none' }}
                                >
                                    Cancelar
                                </Button>
                                <Button 
                                    type="submit" 
                                    variant="contained" 
                                    color="primary"
                                    disabled={isSubmitting}
                                    sx={{ borderRadius: 2, textTransform: 'none' }}
                                >
                                    {isSubmitting ? 'Guardando...' : 'Guardar Configuración'}
                                </Button>
                            </Box>
                        </Form>
                    </Card>
                )}
            </Formik>
        </Box>
    );
};
